import styles from './CountBadge.module.css';

/** The states the Component Test Page draws: a count, a count past ninety-nine, a word, and a word in each tone. */
export const countBadgeDocumentedStates = ['count', 'many', 'soon', 'new'] as const;

/** 🔒 Past ninety-nine the balloon reads 99+, so a long queue never widens the entry it sits on. */
export const COUNT_BADGE_MAX = 99;

/** What the balloon reads: a count, or a word. */
export function countBadgeText(count: number): string {
  return count > COUNT_BADGE_MAX ? `${COUNT_BADGE_MAX}+` : String(count);
}

export interface CountBadgeProps {
  /** The number the balloon carries; a count of zero or less draws nothing. */
  count?: number;
  /** A word in place of a number, Starts Soon or New. */
  word?: string;
  /** What a screen reader hears in its place, the count with its noun. */
  label: string;
  /** Count is the navy balloon; soon the warning one; new the good one. */
  tone?: 'count' | 'soon' | 'new';
}

/**
 * 🔒 The count balloon (piece 4; decision 3072; T2183): one shared control for
 * a count beside a menu entry or a card title, and for a word on a row. A
 * count of zero draws nothing, so an entry with nothing waiting stands bare.
 * 🔨 The text is at the caption size and never below it, so the balloon reads
 * at phone width (the Component Test Page refuses text under 11px there).
 */
export function CountBadge({ count, word, label, tone = 'count' }: CountBadgeProps) {
  const text = word ?? (count !== undefined && count > 0 ? countBadgeText(count) : null);
  if (text === null) return null;
  return (
    <span className={`${styles.badge} ${styles[tone]}`} title={label} data-count-badge={word ?? String(count)} data-count-badge-tone={tone}>
      <span aria-hidden="true">{text}</span>
      <span className={styles.srOnly}>{label}</span>
    </span>
  );
}
